
/**
 * Console
 */
export default class Console {

    /**
     * Special console color command
     */
    public static color(...params: [any?, ...any[]]) {
        let aa = params;
        const options = aa.pop() || {};
        let output;
        let diff;
        const consoleTime: number = window.consoleTime as number || 0;
        const style: string[] = [
            "padding: 2px 20px 2px 2px",
            "width: 100%",
            "display:block",
            "background: " + options.background,
            "color: " + options.color,
        ];

        diff = Date.now() - consoleTime;
        window.consoleTime = Date.now();
        diff = (" ".repeat(Math.max(0, 5 - diff.toString().length))) + diff;
        aa[0] = "%c " + aa[0] + " ";
        // output = aa.join(" ") + " - " + diff + "ms";
        output = diff + "ms > " + aa.join(" ");
        aa = [output, style.join(";")];

        console.log.apply(console, aa);
    }

}
